import { Dispatch } from 'redux';
import { ResourceTypes } from './Types';
import { ApiEndpoints, ActionHandler } from 'Utils';

export const GetAllResources = () => (dispatch: Dispatch) => {
	return ActionHandler(
		{ url: ApiEndpoints.resourceCategory, method: 'GET', dispatch },

		(res) => {
			const { data } = res.data;

			dispatch({ type: ResourceTypes.LOAD_RESOURCES, payload: { data } });
		},
		(error) => {
			// const { data } = error.response;
            //eslint-disable-next-line 
            // console.log(data)
			// dispatch({ type: ResourceTypes.Errors, payload: { errors: data } });
		},
	);
};

export const GetResourceById = (id:string) => (dispatch: Dispatch) => {
	const newUrl = ApiEndpoints.resourceById +`/${id}`
	return ActionHandler(
		{ url: newUrl, method: 'GET', dispatch },

		(res) => {
			const { data } = res.data;
			dispatch({ type: ResourceTypes.LOAD_RESOURCE_DETAILS, payload: { data } });
		},
		(error) => {
			// const { data } = error.response;
            //eslint-disable-next-line 
            // console.log(data)
			// dispatch({ type: ResourceTypes.Errors, payload: { errors: data } });
		},
	);
};
